import { useState, type FormEvent } from 'react';
import { register } from '../sync/authStore';
import { Window } from '../ui/Window';
import { navigate, paths } from './router';

export function RegisterPage({ invite, setup }: { invite: string | null; setup: boolean }) {
  const [code, setCode] = useState(invite ?? '');
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState<string | null>(null);
  const [busy, setBusy] = useState(false);

  const submit = async (e: FormEvent) => {
    e.preventDefault();
    setBusy(true);
    setError(null);
    try {
      await register({ email, password, name, invite: setup ? null : code.trim() });
      navigate(paths.dashboard);
    } catch (err) {
      setError(err instanceof Error ? err.message : String(err));
    } finally {
      setBusy(false);
    }
  };

  return (
    <main className="desktop">
      <Window title={setup ? 'VDS · First user' : 'VDS · Register'}>
        <form className="form" onSubmit={submit}>
          {setup ? (
            <p className="form-hint">No accounts exist yet. This one becomes the owner.</p>
          ) : (
            <label>
              <span>Invite code</span>
              <input required value={code} onChange={(e) => setCode(e.target.value)} autoFocus={!invite} />
            </label>
          )}
          <label>
            <span>Name</span>
            <input value={name} onChange={(e) => setName(e.target.value)} autoFocus={!!invite || setup} />
          </label>
          <label>
            <span>Email</span>
            <input type="email" autoComplete="username" required value={email} onChange={(e) => setEmail(e.target.value)} />
          </label>
          <label>
            <span>Password (8+ characters)</span>
            <input type="password" autoComplete="new-password" required minLength={8} value={password} onChange={(e) => setPassword(e.target.value)} />
          </label>
          {error && <div className="form-error">{error}</div>}
          <div className="form-actions">
            <button type="submit" className="btn btn-primary" disabled={busy}>
              {busy ? 'Creating…' : 'Create account'}
            </button>
            {!setup && (
              <a className="btn" href={paths.login}>
                Sign in instead
              </a>
            )}
          </div>
        </form>
      </Window>
    </main>
  );
}
